// Authorised Distributor Brands Section
// Showcases HVAC brands for which Fix My AC is an authorised distributor

const brands = [
  {
    name: "Mitsubishi Heavy Industries",
    logo: "/brands/mitsubishi.png",
    alt: "Mitsubishi Heavy Industries HVAC - Authorised distributor India",
  },
  {
    name: "Samsung",
    logo: "/brands/samsung.png",
    alt: "Samsung Air Conditioning Systems - Authorised distributor India",
  },
  {
    name: "Voltas",
    logo: "/brands/voltas.png",
    alt: "Voltas HVAC Solutions - Authorised distributor India",
  },
  {
    name: "Hitachi",
    logo: "/brands/hitachi.png",
    alt: "Hitachi Cooling Systems - Authorised distributor India",
  },
];

export const BrandsSection = () => {
  return (
    <section 
      id="brands"
      className="py-16 lg:py-20 bg-white" 
      data-testid="brands-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 lg:mb-16">
          <span className="inline-block text-sm font-semibold text-accent-500 tracking-wider uppercase mb-3">
            Authorised Distributor
          </span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-900 mb-4">
            Authorised Distributor for Leading HVAC Brands
          </h2>
          <div className="w-20 h-1.5 bg-gradient-to-r from-brand-500 to-accent-500 mx-auto rounded-full" />
          <p className="text-slate-500 max-w-2xl mx-auto text-base mt-4">
            Certified partner for Mitsubishi Heavy Industries, Samsung, Voltas, and Hitachi — delivering genuine products with manufacturer warranty across India.
          </p>
        </div>

        {/* Brands Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 lg:gap-10">
          {brands.map((brand) => (
            <div
              key={brand.name}
              className="group flex flex-col items-center"
              data-testid={`brand-${brand.name.toLowerCase().replace(/\s+/g, '-')}`}
            >
              {/* Logo Container */}
              <div className="w-full h-24 sm:h-28 lg:h-32 flex items-center justify-center p-4 sm:p-6 bg-slate-50 rounded-xl border border-slate-100 transition-all duration-300 group-hover:shadow-lg group-hover:scale-105 group-hover:-translate-y-1 group-hover:border-brand-200 cursor-pointer">
                <img
                  src={brand.logo}
                  alt={brand.alt}
                  className="max-h-full max-w-full object-contain"
                  loading="lazy"
                  width="150"
                  height="80"
                />
              </div>
              {/* Brand Name */}
              <p className="mt-3 text-sm sm:text-base font-medium text-slate-700 text-center group-hover:text-brand-600 transition-colors duration-300">
                {brand.name}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
